// extracted by mini-css-extract-plugin
export var root = "vcuX";
export var rootActionLink = "GBSs";
export var rootContainer = "br8M";
export var rootCounterLabel = "gqHR";
export var rootCounterWrapper = "uwLk";
export var rootRow = "ADrJ";
export var rootText = "FvRZ";
export var rootTextWrapper = "_3s6B";